import { create } from 'zustand';

interface SearchStore {
  pendingQuery: string | null;
  isTransitioning: boolean;
  startSearchTransition: (query: string) => void;
  completeSearchTransition: () => void;
}

export const useSearchStore = create<SearchStore>()((set) => ({
  pendingQuery: null,
  isTransitioning: false,
  startSearchTransition: (query) => set({ pendingQuery: query, isTransitioning: true }),
  completeSearchTransition: () => set({ pendingQuery: null, isTransitioning: false }),
}));
